module.exports = __webpack_public_path__ + "img/HZ-S4037.1dc0dad0.jpg";